var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31722 0.682412C6.5692 0.430426 7.00006 0.608893 7.00006 0.965255V6.59957C7.00006 6.82048 6.82097 6.99957 6.60006 6.99957H0.965743C0.609381 6.99957 0.430915 6.56871 0.682901 6.31673L6.31722 0.682412Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarGroupIcon);
export default __webpack_public_path__ + "static/media/sidebarGroupIcon.29dec0048de171e1848c309fa48d751f.svg";
export { ForwardRef as ReactComponent };